import { render, staticRenderFns } from "./ScreeningProcessAlert.vue?vue&type=template&id=4a3539cd&scoped=true&"
import script from "./ScreeningProcessAlert.vue?vue&type=script&lang=js&"
export * from "./ScreeningProcessAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3539cd",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAlert,VChip})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a3539cd')) {
      api.createRecord('4a3539cd', component.options)
    } else {
      api.reload('4a3539cd', component.options)
    }
    module.hot.accept("./ScreeningProcessAlert.vue?vue&type=template&id=4a3539cd&scoped=true&", function () {
      api.rerender('4a3539cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/ScreeningProcessAlert.vue"
export default component.exports